<template>
  <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" />
</template>
